{
  "actions": "Handlinger",
  "hideButtonLabel": "Vis mindre",
  "showAllButtonLabel": "Vis alle ({tagCount, number})"
}
